const features = [
  {
    icon: 'ri-flashlight-line',
    title: '极速更新',
    desc: '最新电视剧全集播出后数小时内上线，每日同步更新国产剧、韩剧、美剧、日剧最新资源，追剧无需等待。',
  },
  {
    icon: 'ri-hd-line',
    title: '高清画质',
    desc: '所有剧集提供高清流畅播放体验，优化播放链路，拒绝缓冲卡顿，让每一次追剧都是享受。',
  },
  {
    icon: 'ri-global-line',
    title: '全品类覆盖',
    desc: '国产剧全集在线、韩剧全集免费、美剧全集播放、日剧全集资源全覆盖，12个内容分类任你选择。',
  },
  {
    icon: 'ri-shield-check-line',
    title: '免费开放',
    desc: '无需注册、无需付费、无需下载 App，所有剧集资源免费在线观看。打开浏览器即可畅享追剧乐趣。',
  },
  {
    icon: 'ri-device-line',
    title: '多端适配',
    desc: '桌面、平板、手机全端自适应，浏览器直接访问即可获得最佳观影体验，随时随地想追就追。',
  },
];

export default function FeaturesSection() {
  return (
    <section id="features" className="py-14 md:py-20 bg-background-100">
      <div className="px-4 md:px-6">
        <div className="max-w-[1400px] mx-auto">
          <div className="text-center mb-10">
            <span className="inline-block text-xs font-medium text-primary-600 bg-primary-100 px-3 py-1 rounded-full mb-3">
              为什么选择我们
            </span>
            <h2 className="text-xl md:text-3xl font-bold font-heading text-foreground-950">
              平台特色
            </h2>
            <p className="text-sm text-foreground-500 mt-2">天天影院的核心优势</p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
            {features.map((feat, i) => (
              <div
                key={i}
                className="group bg-background-50 rounded-xl p-6 md:p-7 border border-background-200/70 hover:border-primary-200 transition-all cursor-pointer"
              >
                <div className="w-11 h-11 flex items-center justify-center bg-primary-100 text-primary-600 rounded-xl mb-4 group-hover:bg-primary-500 group-hover:text-background-50 transition-colors">
                  <i className={`${feat.icon} text-lg`}></i>
                </div>
                <h3 className="text-base font-bold text-foreground-900 mb-2 font-heading">{feat.title}</h3>
                <p className="text-sm text-foreground-500 leading-relaxed">{feat.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}